import type React from "react";
import { useId } from "react";

import { FormControl } from "~/components/FormControl";
import { PasswordInput } from "~/components/PasswordInput";

export const PasswordField: React.FC = () => {
  const id = useId();
  return (
    <FormControl id={id} label="Password">
      <PasswordInput required id={id} name="password" />
    </FormControl>
  );
};
